/**
 * Enumeration with all available Layouts and their directory name.
 */
enum Layout {
  Quokka = "quokka",
}

export default Layout;
